// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-1h0bs","root_checked":"root_checked-2kl8_","root_disabled":"root_disabled-2B2hO","label":"label-2Pllu"};